export const externalMenu = [
  // {
  //   label: "数据统计",
  //   value: "statistics",
  //   children: [{ label: "数据看板", value: "project-statistics-board" }]
  // },
  {
    label: "任务甘特图",
    value: "project-task-gantt"
  },
  {
    label: "项目概览",
    value: "project-overview"
  },
  {
    label: "项目里程碑",
    value: "project-milestone"
  },
  {
    label: "项目风险",
    value: "project-risk"
  }
]

export const templateTabs = [
  {
    label: "任务",
    value: "TaskList"
  },
  {
    label: "管理",
    value: "Setting"
  }
]
